export default __webpack_public_path__ + "static/media/pic4.2d0c6e6d.jpg";